module.exports = __webpack_public_path__ + "img/bg-inventory.9886d16f.jpeg";